export const BREAKPOINT_PHONE = 400;
export const BREAKPOINT_PHONE_WIDE = 480;
export const BREAKPOINT_PHABLET = 560;
export const BREAKPOINT_TABLET_SMALL = 640;
export const BREAKPOINT_TABLET = 850;
export const BREAKPOINT_TABLET_WIDE = 1024;
export const BREAKPOINT_DESKTOP = 1248;
export const BREAKPOINT_DESKTOP_WIDE = 1440;
